export enum InsuranceTypeOptions {
  PRIVATE_INSURANCE = 'PRIVATE_INSURANCE',
  SOCIAL_INSURANCE = 'SOCIAL_INSURANCE',
  ADDITIONAL_PRIVATE_INSURANCE = 'ADDITIONAL_PRIVATE_INSURANCE',
}
